import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../button';

function Banner(props) {
    const { item } = props;

    return (
        <div className="project-box">
            <div className="image">
                <img className="mask move" src={item.img} alt="Cerv" />
            </div>
            <div className="content">
                <span className="boder"></span>
                <div className="content-inner">
                    <h5
                        className="heading"
                        style={{
                            height: '60px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '14px'
                        }}
                    >
                        <Link to={item.link}>{item.title}</Link>
                    </h5>
                    <p
                        className="desc"
                        style={{
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '12px',
                            lineHeight: '1'
                        }}
                    >
                        {item.desc}
                    </p>
                </div>
            </div>
            <Button title='EXPLORAR' path={item.link} addclass='style1' />
        </div>
    );
}

export default Banner;